export function getWidthBySideWidth(sideWidth) {
  return 2 * Math.sqrt(3) * sideWidth;
}

export function getHeightBySideWidth(sideWidth) {
  return 4 * sideWidth;
}
